export const getBannersByColId = (id='') => window.axios.post(`currency/getBannersByColId?colId=${id}`)
export const getArticleListByColId = (id='', pageNum=1, pageSize=30) => window.axios.post(`currency/getArticleListByColId?colId=${id}&pageNum=${pageNum}&pageSize=${pageSize}`)
